export default __webpack_public_path__ + "static/media/photo-charte04.cbcac84a.png";